import {useNavigation, useRoute} from '@react-navigation/native';
import {useAppSelector} from '../../store/hooks';
import {Animated, Image, ImageBackground, View} from 'react-native';
import {useMutation} from 'react-query';
import {
  EditorComment,
  EditorProject,
  EncoderProject,
} from '../../types';
import {
  PanGestureHandler,
  TouchableOpacity,
  State,
} from 'react-native-gesture-handler';
import {IconButton, List, ProgressBar} from 'react-native-paper';
import React from 'react';
const minDuration = 40;

const EditorContentItem = ({
  item,
  onDragEnd,
  onDragStart,
  index,
  layerIndex,
  writeItem,
  parentDataHook,
}: {
  item: EncoderProject | EditorComment;
  folder: EditorProject;
}) => {
  const nav = useNavigation();
  const route = useRoute();
  const editor = useAppSelector(state => state.editor);
  const {pixelsPerSecond} = editor;
  const maxDuration = ((item?.duration || 0) - 1) * pixelsPerSecond;
  const start = item.encoding?.start || 0;
  const end = item.encoding?.end || item.duration;
  let currentDuration = end
    ? (end - start) * pixelsPerSecond
    : maxDuration;
  // if(currentDuration < minDuration)
  // 	currentDuration = minDuration / 2
  let width = new Animated.Value(currentDuration);
  const writeItemMutation = useMutation((item: EncoderProject) =>
    writeItem(item),
  );
  const onGestureEvent = Animated.event(
    [
      {
        nativeEvent: {
          translationX: width,
        },
      },
    ],
    {
      listener: event => {
        // console.info('ongesture', event)
      },
      useNativeDriver: false,
    },
  );
  const combIndex = index + layerIndex;
  let backgroundColor = combIndex % 2 ? 'darkcyan' : 'green';
  if (combIndex % 3 > 1) backgroundColor = 'darkslateblue';

  const isSelected =
    item.id === route.params?.encoder ||
    item.id === route.params?.chatId;
  const onHandlerStateChange = async event => {
    if (event.nativeEvent.oldState === State.ACTIVE) {
      let newvalue = width._value;

      if (newvalue > maxDuration) newvalue = maxDuration;
      if (newvalue < minDuration) newvalue = minDuration;

      if (width._value !== newvalue) width.setValue(newvalue);

      if (!item.encoding) item.encoding = {};
      newvalue = newvalue / pixelsPerSecond;
      if (newvalue < item.encoding?.start || 0)
        newvalue += item.encoding?.start;
      item.encoding.end = newvalue;
      // item.encoding.lastUpdated = new Date().valueOf()
      await writeItemMutation.mutateAsync(item);
    }
  };
  const isDownloading = useAppSelector(
    state => state.fs.downloadingProgress[item.id],
  );
  // console.info('pixelsperSecond', pixelsPerSecond);
  const spectrogram = item.audioSpectrogram_small;
  return (
    <View key={item.id} style={{height: 68, position: 'relative'}}>
      <Animated.View
        style={{
          width: width.interpolate({
            inputRange: [start, maxDuration],
            outputRange: [start, maxDuration],
            extrapolate: 'clamp',
          }),
          height: '100%',
          top: 0,
          padding: 0,
          margin: 0,
          left: item.currentPosition
            ? pixelsPerSecond * item.currentPosition
            : 0,
          position: item.currentPosition ? 'absolute' : 'relative',
          backgroundColor,
          zIndex: 2,
          overflow: 'hidden',
          borderWidth: isSelected ? 1 : 0,
          borderRadius: 0,
          borderColor: 'white',
        }}>
        <PanGestureHandler
          onGestureEvent={onGestureEvent}
          onHandlerStateChange={onHandlerStateChange}>
          <View
            style={{
              position: 'absolute',
              right: 0,
              bottom: 0,
              cursor: 'pointer',
              zIndex: 100,
            }}>
            <List.Icon
              icon={'resize-bottom-right'}
              style={{padding: 0, margin: 0}}
            />
          </View>
        </PanGestureHandler>
        <List.Item
          onPress={() =>
            nav.setParams({
              ...route.params,
              encoder: !isSelected ? item.id : undefined,
              chatId: undefined,
            })
          }
          style={{height: '100%', zIndex: 10}}
          left={() => (
            <TouchableOpacity
              onPressIn={onDragStart}
              onPressOut={onDragEnd}
              style={{pointerEvents: 'auto'}}>
              <IconButton size={18} icon={'drag'} />
            </TouchableOpacity>
          )}
          title={item.title}
          right={() => (
            <>
              {/* <IconButton
                size={18}
                icon={'delete'}
                onPress={deleteItem}
              /> */}
            </>
          )}
        />
        {spectrogram ? (
          <Image
            source={{
              uri: spectrogram,
              cache: 'force-cache',
            }}
            // resizeMethod="auto"
            resizeMode="cover"
            style={{
              // ...MediaItemStyles.image,
              // height,
              height: 68,
              width: item.duration * pixelsPerSecond,
              position: 'absolute',
              top: 0,
              // left:0,
              left: -(start * pixelsPerSecond),
              // paddingRight: 20,
              // alignSelf: 'flex-end',
            }}
          />
        ) : // </View>
        null}
        {isDownloading ? (
          <ProgressBar
            style={{
              width,
              height: '100%',
              top: '-100%',
              position: 'absolute',
              left: 0,
              opacity: 0.5,
            }}
            progress={isDownloading}
          />
        ) : null}
      </Animated.View>
    </View>
  );
};

export default EditorContentItem;
